import { render } from "./LogosOurPartners.vue?vue&type=template&id=154d5f74&scoped=true&ts=true"
import script from "./LogosOurPartners.vue?vue&type=script&lang=ts"
export * from "./LogosOurPartners.vue?vue&type=script&lang=ts"

import "./LogosOurPartners.vue?vue&type=style&index=0&id=154d5f74&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154d5f74"]])

export default __exports__